export const DOG_BREEDS = [
  {
    value: 'Afador',
    label: 'Afador',
  },
  {
    value: 'Affenhuahua',
    label: 'Affenhuahua',
  },
  {
    value: 'Affenpinscher',
    label: 'Affenpinscher',
  },
  {
    value: 'Afghan Hound',
    label: 'Afghan Hound',
  },
  {
    value: 'Airedale Terrier',
    label: 'Airedale Terrier',
  },
  {
    value: 'Akbash',
    label: 'Akbash',
  },
  {
    value: 'Akita',
    label: 'Akita',
  },
  {
    value: 'Akita Chow',
    label: 'Akita Chow',
  },
  {
    value: 'Akita Pit',
    label: 'Akita Pit',
  },
  {
    value: 'Akita Shepherd',
    label: 'Akita Shepherd',
  },
  {
    value: 'Alaskan Klee Kai',
    label: 'Alaskan Klee Kai',
  },
  {
    value: 'Alaskan Malamute',
    label: 'Alaskan Malamute',
  },
  {
    value: 'American Bulldog',
    label: 'American Bulldog',
  },
  {
    value: 'American English Coonhound',
    label: 'American English Coonhound',
  },
  {
    value: 'American Eskimo Dog',
    label: 'American Eskimo Dog',
  },
  {
    value: 'American Foxhound',
    label: 'American Foxhound',
  },
  {
    value: 'American Hairless Terrier',
    label: 'American Hairless Terrier',
  },
  {
    value: 'American Leopard Hound',
    label: 'American Leopard Hound',
  },
  {
    value: 'American Pit Bull Terrier',
    label: 'American Pit Bull Terrier',
  },
  {
    value: 'American Pugabull',
    label: 'American Pugabull',
  },
  {
    value: 'American Staffordshire Terrier',
    label: 'American Staffordshire Terrier',
  },
  {
    value: 'American Water Spaniel',
    label: 'American Water Spaniel',
  },
  {
    value: 'Anatolian Shepherd Dog',
    label: 'Anatolian Shepherd Dog',
  },
  {
    value: 'Appenzeller Sennenhunde',
    label: 'Appenzeller Sennenhunde',
  },
  {
    value: 'Auggie',
    label: 'Auggie',
  },
  {
    value: 'Aussiedoodle',
    label: 'Aussiedoodle',
  },
  {
    value: 'Aussiepom',
    label: 'Aussiepom',
  },
  {
    value: 'Australian Cattle Dog',
    label: 'Australian Cattle Dog',
  },
  {
    value: 'Australian Kelpie',
    label: 'Australian Kelpie',
  },
  {
    value: 'Australian Retriever',
    label: 'Australian Retriever',
  },
  {
    value: 'Australian Shepherd',
    label: 'Australian Shepherd',
  },
  {
    value: 'Australian Shepherd Husky',
    label: 'Australian Shepherd Husky',
  },
  {
    value: 'Australian Shepherd Lab Mix',
    label: 'Australian Shepherd Lab Mix',
  },
  {
    value: 'Australian Shepherd Pit Bull Mix',
    label: 'Australian Shepherd Pit Bull Mix',
  },
  {
    value: 'Australian Stumpy Tail Cattle Dog',
    label: 'Australian Stumpy Tail Cattle Dog',
  },
  {
    value: 'Australian Terrier',
    label: 'Australian Terrier',
  },
  {
    value: 'Azawakh',
    label: 'Azawakh',
  },
  {
    value: 'Barbet',
    label: 'Barbet',
  },
  {
    value: 'Basenji',
    label: 'Basenji',
  },
  {
    value: 'Bassador',
    label: 'Bassador',
  },
  {
    value: 'Basset Fauve de Bretagne',
    label: 'Basset Fauve de Bretagne',
  },
  {
    value: 'Basset Hound',
    label: 'Basset Hound',
  },
  {
    value: 'Basset Retriever',
    label: 'Basset Retriever',
  },
  {
    value: 'Bavarian Mountain Scent Hound',
    label: 'Bavarian Mountain Scent Hound',
  },
  {
    value: 'Beabull',
    label: 'Beabull',
  },
  {
    value: 'Beagle',
    label: 'Beagle',
  },
  {
    value: 'Beaglier',
    label: 'Beaglier',
  },
  {
    value: 'Bearded Collie',
    label: 'Bearded Collie',
  },
  {
    value: 'Bedlington Terrier',
    label: 'Bedlington Terrier',
  },
  {
    value: 'Belgian Laekenois',
    label: 'Belgian Laekenois',
  },
  {
    value: 'Belgian Malinois',
    label: 'Belgian Malinois',
  },
  {
    value: 'Belgian Sheepdog',
    label: 'Belgian Sheepdog',
  },
  {
    value: 'Belgian Tervuren',
    label: 'Belgian Tervuren',
  },
  {
    value: 'Bergamasco Sheepdog',
    label: 'Bergamasco Sheepdog',
  },
  {
    value: 'Berger Picard',
    label: 'Berger Picard',
  },
  {
    value: 'Bernedoodle',
    label: 'Bernedoodle',
  },
  {
    value: 'Bernese Mountain Dog',
    label: 'Bernese Mountain Dog',
  },
  {
    value: 'Bichon Frise',
    label: 'Bichon Frise',
  },
  {
    value: 'Biewer Terrier',
    label: 'Biewer Terrier',
  },
  {
    value: 'Black and Tan Coonhound',
    label: 'Black and Tan Coonhound',
  },
  {
    value: 'Black Mouth Cur',
    label: 'Black Mouth Cur',
  },
  {
    value: 'Black Russian Terrier',
    label: 'Black Russian Terrier',
  },
  {
    value: 'Bloodhound',
    label: 'Bloodhound',
  },
  {
    value: 'Blue Lacy',
    label: 'Blue Lacy',
  },
  {
    value: 'Bluetick Coonhound',
    label: 'Bluetick Coonhound',
  },
  {
    value: 'Bocker',
    label: 'Bocker',
  },
  {
    value: 'Boerboel',
    label: 'Boerboel',
  },
  {
    value: 'Boglen Terrier',
    label: 'Boglen Terrier',
  },
  {
    value: 'Bohemian Shepherd',
    label: 'Bohemian Shepherd',
  },
  {
    value: 'Bolognese',
    label: 'Bolognese',
  },
  {
    value: 'Borador',
    label: 'Borador',
  },
  {
    value: 'Border Collie',
    label: 'Border Collie',
  },
  {
    value: 'Border Sheepdog',
    label: 'Border Sheepdog',
  },
  {
    value: 'Border Terrier',
    label: 'Border Terrier',
  },
  {
    value: 'Bordoodle',
    label: 'Bordoodle',
  },
  {
    value: 'Borzoi',
    label: 'Borzoi',
  },
  {
    value: 'BoShih',
    label: 'BoShih',
  },
  {
    value: 'Bossie',
    label: 'Bossie',
  },
  {
    value: 'Boston Boxer',
    label: 'Boston Boxer',
  },
  {
    value: 'Boston Terrier',
    label: 'Boston Terrier',
  },
  {
    value: 'Boston Terrier Pekingese Mix',
    label: 'Boston Terrier Pekingese Mix',
  },
  {
    value: 'Bouvier des Flandres',
    label: 'Bouvier des Flandres',
  },
  {
    value: 'Boxador',
    label: 'Boxador',
  },
  {
    value: 'Boxer',
    label: 'Boxer',
  },
  {
    value: 'Boxerdoodle',
    label: 'Boxerdoodle',
  },
  {
    value: 'Boxmatian',
    label: 'Boxmatian',
  },
  {
    value: 'Boxweiler',
    label: 'Boxweiler',
  },
  {
    value: 'Boykin Spaniel',
    label: 'Boykin Spaniel',
  },
  {
    value: 'Bracco Italiano',
    label: 'Bracco Italiano',
  },
  {
    value: 'Braque du Bourbonnais',
    label: 'Braque du Bourbonnais',
  },
  {
    value: 'Briard',
    label: 'Briard',
  },
  {
    value: 'Brittany',
    label: 'Brittany',
  },
  {
    value: 'Broholmer',
    label: 'Broholmer',
  },
  {
    value: 'Brussels Griffon',
    label: 'Brussels Griffon',
  },
  {
    value: 'Bugg',
    label: 'Bugg',
  },
  {
    value: 'Bull Arab',
    label: 'Bull Arab',
  },
  {
    value: 'Bull-Pei',
    label: 'Bull-Pei',
  },
  {
    value: 'Bull Terrier',
    label: 'Bull Terrier',
  },
  {
    value: 'Bullador',
    label: 'Bullador',
  },
  {
    value: 'Bullboxer Pit',
    label: 'Bullboxer Pit',
  },
  {
    value: 'Bulldog',
    label: 'Bulldog',
  },
  {
    value: 'Bullmastiff',
    label: 'Bullmastiff',
  },
  {
    value: 'Bullmatian',
    label: 'Bullmatian',
  },
  {
    value: 'Cairn Terrier',
    label: 'Cairn Terrier',
  },
  {
    value: 'Canaan Dog',
    label: 'Canaan Dog',
  },
  {
    value: 'Cane Corso',
    label: 'Cane Corso',
  },
  {
    value: 'Cardigan Welsh Corgi',
    label: 'Cardigan Welsh Corgi',
  },
  {
    value: 'Carolina Dog',
    label: 'Carolina Dog',
  },
  {
    value: 'Catahoula Bulldog',
    label: 'Catahoula Bulldog',
  },
  {
    value: 'Catahoula Leopard Dog',
    label: 'Catahoula Leopard Dog',
  },
  {
    value: 'Caucasian Shepherd Dog',
    label: 'Caucasian Shepherd Dog',
  },
  {
    value: 'Cav-a-Jack',
    label: 'Cav-a-Jack',
  },
  {
    value: 'Cavachon',
    label: 'Cavachon',
  },
  {
    value: 'Cavador',
    label: 'Cavador',
  },
  {
    value: 'Cavalier King Charles Spaniel',
    label: 'Cavalier King Charles Spaniel',
  },
  {
    value: 'Cavapoo',
    label: 'Cavapoo',
  },
  {
    value: 'Central Asian Shepherd Dog',
    label: 'Central Asian Shepherd Dog',
  },
  {
    value: 'Cesky Terrier',
    label: 'Cesky Terrier',
  },
  {
    value: 'Chabrador',
    label: 'Chabrador',
  },
  {
    value: 'Cheagle',
    label: 'Cheagle',
  },
  {
    value: 'Chesapeake Bay Retriever',
    label: 'Chesapeake Bay Retriever',
  },
  {
    value: 'Chi Chi',
    label: 'Chi Chi',
  },
  {
    value: 'Chi-Poo',
    label: 'Chi-Poo',
  },
  {
    value: 'Chigi',
    label: 'Chigi',
  },
  {
    value: 'Chihuahua',
    label: 'Chihuahua',
  },
  {
    value: 'Chilier',
    label: 'Chilier',
  },
  {
    value: 'Chinese Crested',
    label: 'Chinese Crested',
  },
  {
    value: 'Chinese Shar-Pei',
    label: 'Chinese Shar-Pei',
  },
  {
    value: 'Chinook',
    label: 'Chinook',
  },
  {
    value: 'Chion',
    label: 'Chion',
  },
  {
    value: 'Chipin',
    label: 'Chipin',
  },
  {
    value: 'Chiweenie',
    label: 'Chiweenie',
  },
  {
    value: 'Chorkie',
    label: 'Chorkie',
  },
  {
    value: 'Chow Chow',
    label: 'Chow Chow',
  },
  {
    value: 'Chow Shepherd',
    label: 'Chow Shepherd',
  },
  {
    value: 'Chug',
    label: 'Chug',
  },
  {
    value: 'Chusky',
    label: 'Chusky',
  },
  {
    value: 'Cirneco dell’Etna',
    label: 'Cirneco dell’Etna',
  },
  {
    value: 'Clumber Spaniel',
    label: 'Clumber Spaniel',
  },
  {
    value: 'Cockalier',
    label: 'Cockalier',
  },
  {
    value: 'Cockapoo',
    label: 'Cockapoo',
  },
  {
    value: 'Cocker Spaniel',
    label: 'Cocker Spaniel',
  },
  {
    value: 'Collie',
    label: 'Collie',
  },
  {
    value: 'Corgi Inu',
    label: 'Corgi Inu',
  },
  {
    value: 'Corgvalueor',
    label: 'Corgvalueor',
  },
  {
    value: 'Corman Shepherd',
    label: 'Corman Shepherd',
  },
  {
    value: 'Coton de Tulear',
    label: 'Coton de Tulear',
  },
  {
    value: 'Croatian Sheepdog',
    label: 'Croatian Sheepdog',
  },
  {
    value: 'Curly-Coated Retriever',
    label: 'Curly-Coated Retriever',
  },
  {
    value: 'Dachsador',
    label: 'Dachsador',
  },
  {
    value: 'Dachshund',
    label: 'Dachshund',
  },
  {
    value: 'Dalmatian',
    label: 'Dalmatian',
  },
  {
    value: 'Dandie Dinmont Terrier',
    label: 'Dandie Dinmont Terrier',
  },
  {
    value: 'Daniff',
    label: 'Daniff',
  },
  {
    value: 'Danish-Swedish Farmdog',
    label: 'Danish-Swedish Farmdog',
  },
  {
    value: 'Deutscher Wachtelhund',
    label: 'Deutscher Wachtelhund',
  },
  {
    value: 'Doberdor',
    label: 'Doberdor',
  },
  {
    value: 'Doberman Pinscher',
    label: 'Doberman Pinscher',
  },
  {
    value: 'Docker',
    label: 'Docker',
  },
  {
    value: 'Dogo Argentino',
    label: 'Dogo Argentino',
  },
  {
    value: 'Dogue de Bordeaux',
    label: 'Dogue de Bordeaux',
  },
  {
    value: 'Dorgi',
    label: 'Dorgi',
  },
  {
    value: 'Dorkie',
    label: 'Dorkie',
  },
  {
    value: 'Doxiepoo',
    label: 'Doxiepoo',
  },
  {
    value: 'Doxle',
    label: 'Doxle',
  },
  {
    value: 'Drentsche Patrijshond',
    label: 'Drentsche Patrijshond',
  },
  {
    value: 'Drever',
    label: 'Drever',
  },
  {
    value: 'Dutch Shepherd',
    label: 'Dutch Shepherd',
  },
  {
    value: 'English Cocker Spaniel',
    label: 'English Cocker Spaniel',
  },
  {
    value: 'English Foxhound',
    label: 'English Foxhound',
  },
  {
    value: 'English Setter',
    label: 'English Setter',
  },
  {
    value: 'English Springer Spaniel',
    label: 'English Springer Spaniel',
  },
  {
    value: 'English Toy Spaniel',
    label: 'English Toy Spaniel',
  },
  {
    value: 'Entlebucher Mountain Dog',
    label: 'Entlebucher Mountain Dog',
  },
  {
    value: 'Estrela Mountain Dog',
    label: 'Estrela Mountain Dog',
  },
  {
    value: 'Eurasier',
    label: 'Eurasier',
  },
  {
    value: 'Field Spaniel',
    label: 'Field Spaniel',
  },
  {
    value: 'Fila Brasileiro',
    label: 'Fila Brasileiro',
  },
  {
    value: 'Finnish Lapphund',
    label: 'Finnish Lapphund',
  },
  {
    value: 'Finnish Spitz',
    label: 'Finnish Spitz',
  },
  {
    value: 'Flat-Coated Retriever',
    label: 'Flat-Coated Retriever',
  },
  {
    value: 'Fox Terrier',
    label: 'Fox Terrier',
  },
  {
    value: 'French Bulldog',
    label: 'French Bulldog',
  },
  {
    value: 'French Bullhuahua',
    label: 'French Bullhuahua',
  },
  {
    value: 'French Spaniel',
    label: 'French Spaniel',
  },
  {
    value: 'Frenchton',
    label: 'Frenchton',
  },
  {
    value: 'Frengle',
    label: 'Frengle',
  },
  {
    value: 'German Longhaired Pointer',
    label: 'German Longhaired Pointer',
  },
  {
    value: 'German Pinscher',
    label: 'German Pinscher',
  },
  {
    value: 'German Shepherd Dog',
    label: 'German Shepherd Dog',
  },
  {
    value: 'German Shepherd Pit Bull',
    label: 'German Shepherd Pit Bull',
  },
  {
    value: 'German Shepherd Rottweiler Mix',
    label: 'German Shepherd Rottweiler Mix',
  },
  {
    value: 'German Sheprador',
    label: 'German Sheprador',
  },
  {
    value: 'German Shorthaired Pointer',
    label: 'German Shorthaired Pointer',
  },
  {
    value: 'German Spitz',
    label: 'German Spitz',
  },
  {
    value: 'German Wirehaired Pointer',
    label: 'German Wirehaired Pointer',
  },
  {
    value: 'Giant Schnauzer',
    label: 'Giant Schnauzer',
  },
  {
    value: 'Glen of Imaal Terrier',
    label: 'Glen of Imaal Terrier',
  },
  {
    value: 'Goberian',
    label: 'Goberian',
  },
  {
    value: 'Goldador',
    label: 'Goldador',
  },
  {
    value: 'Golden Cocker Retriever',
    label: 'Golden Cocker Retriever',
  },
  {
    value: 'Golden Mountain Dog',
    label: 'Golden Mountain Dog',
  },
  {
    value: 'Golden Retriever',
    label: 'Golden Retriever',
  },
  {
    value: 'Golden Retriever Corgi',
    label: 'Golden Retriever Corgi',
  },
  {
    value: 'Golden Shepherd',
    label: 'Golden Shepherd',
  },
  {
    value: 'Goldendoodle',
    label: 'Goldendoodle',
  },
  {
    value: 'Gollie',
    label: 'Gollie',
  },
  {
    value: 'Gordon Setter',
    label: 'Gordon Setter',
  },
  {
    value: 'Great Dane',
    label: 'Great Dane',
  },
  {
    value: 'Great Pyrenees',
    label: 'Great Pyrenees',
  },
  {
    value: 'Greater Swiss Mountain Dog',
    label: 'Greater Swiss Mountain Dog',
  },
  {
    value: 'Greyador',
    label: 'Greyador',
  },
  {
    value: 'Greyhound',
    label: 'Greyhound',
  },
  {
    value: 'Hamiltonstovare',
    label: 'Hamiltonstovare',
  },
  {
    value: 'Hanoverian Scenthound',
    label: 'Hanoverian Scenthound',
  },
  {
    value: 'Harrier',
    label: 'Harrier',
  },
  {
    value: 'Havanese',
    label: 'Havanese',
  },
  {
    value: 'Havapoo',
    label: 'Havapoo',
  },
  {
    value: 'Hokkavalueo',
    label: 'Hokkavalueo',
  },
  {
    value: 'Horgi',
    label: 'Horgi',
  },
  {
    value: 'Hovawart',
    label: 'Hovawart',
  },
  {
    value: 'Huskita',
    label: 'Huskita',
  },
  {
    value: 'Huskydoodle',
    label: 'Huskydoodle',
  },
  {
    value: 'Ibizan Hound',
    label: 'Ibizan Hound',
  },
  {
    value: 'Icelandic Sheepdog',
    label: 'Icelandic Sheepdog',
  },
  {
    value: 'Irish Red And White Setter',
    label: 'Irish Red And White Setter',
  },
  {
    value: 'Irish Setter',
    label: 'Irish Setter',
  },
  {
    value: 'Irish Terrier',
    label: 'Irish Terrier',
  },
  {
    value: 'Irish Water Spaniel',
    label: 'Irish Water Spaniel',
  },
  {
    value: 'Irish Wolfhound',
    label: 'Irish Wolfhound',
  },
  {
    value: 'Italian Greyhound',
    label: 'Italian Greyhound',
  },
  {
    value: 'Jack-A-Poo',
    label: 'Jack-A-Poo',
  },
  {
    value: 'Jack Chi',
    label: 'Jack Chi',
  },
  {
    value: 'Jack Russell Terrier',
    label: 'Jack Russell Terrier',
  },
  {
    value: 'Jackshund',
    label: 'Jackshund',
  },
  {
    value: 'Japanese Chin',
    label: 'Japanese Chin',
  },
  {
    value: 'Japanese Spitz',
    label: 'Japanese Spitz',
  },
  {
    value: 'Korean Jindo Dog',
    label: 'Korean Jindo Dog',
  },
  {
    value: 'Kai Ken',
    label: 'Kai Ken',
  },
  {
    value: 'Karelian Bear Dog',
    label: 'Karelian Bear Dog',
  },
  {
    value: 'Keeshond',
    label: 'Keeshond',
  },
  {
    value: 'Kerry Blue Terrier',
    label: 'Kerry Blue Terrier',
  },
  {
    value: 'King Shepherd',
    label: 'King Shepherd',
  },
  {
    value: 'Kishu Ken',
    label: 'Kishu Ken',
  },
  {
    value: 'Komondor',
    label: 'Komondor',
  },
  {
    value: 'Kooikerhondje',
    label: 'Kooikerhondje',
  },
  {
    value: 'Kuvasz',
    label: 'Kuvasz',
  },
  {
    value: 'Kyi-Leo',
    label: 'Kyi-Leo',
  },
  {
    value: 'Lab Pointer',
    label: 'Lab Pointer',
  },
  {
    value: 'Labernese',
    label: 'Labernese',
  },
  {
    value: 'Labmaraner',
    label: 'Labmaraner',
  },
  {
    value: 'Labrabull',
    label: 'Labrabull',
  },
  {
    value: 'Labradane',
    label: 'Labradane',
  },
  {
    value: 'Labradoodle',
    label: 'Labradoodle',
  },
  {
    value: 'Labrador Retriever',
    label: 'Labrador Retriever',
  },
  {
    value: 'Labrastaff',
    label: 'Labrastaff',
  },
  {
    value: 'Labsky',
    label: 'Labsky',
  },
  {
    value: 'Lagotto Romagnolo',
    label: 'Lagotto Romagnolo',
  },
  {
    value: 'Lakeland Terrier',
    label: 'Lakeland Terrier',
  },
  {
    value: 'Lancashire Heeler',
    label: 'Lancashire Heeler',
  },
  {
    value: 'Leonberger',
    label: 'Leonberger',
  },
  {
    value: 'Lhasa Apso',
    label: 'Lhasa Apso',
  },
  {
    value: 'Lhasapoo',
    label: 'Lhasapoo',
  },
  {
    value: 'Lowchen',
    label: 'Lowchen',
  },
  {
    value: 'Maltese',
    label: 'Maltese',
  },
  {
    value: 'Maltese Shih Tzu',
    label: 'Maltese Shih Tzu',
  },
  {
    value: 'Maltipoo',
    label: 'Maltipoo',
  },
  {
    value: 'Manchester Terrier',
    label: 'Manchester Terrier',
  },
  {
    value: 'Maremma Sheepdog',
    label: 'Maremma Sheepdog',
  },
  {
    value: 'Mastador',
    label: 'Mastador',
  },
  {
    value: 'Mastiff',
    label: 'Mastiff',
  },
  {
    value: 'Miniature Pinscher',
    label: 'Miniature Pinscher',
  },
  {
    value: 'Miniature Schnauzer',
    label: 'Miniature Schnauzer',
  },
  {
    value: 'Morkie',
    label: 'Morkie',
  },
  {
    value: 'Mountain Cur',
    label: 'Mountain Cur',
  },
  {
    value: 'Mountain Feist',
    label: 'Mountain Feist',
  },
  {
    value: 'Mudi',
    label: 'Mudi',
  },
  {
    value: 'Mutt (Mixed)',
    label: 'Mutt (Mixed)',
  },
  {
    value: 'Neapolitan Mastiff',
    label: 'Neapolitan Mastiff',
  },
  {
    value: 'Newfoundland',
    label: 'Newfoundland',
  },
  {
    value: 'Norfolk Terrier',
    label: 'Norfolk Terrier',
  },
  {
    value: 'Northern Inuit Dog',
    label: 'Northern Inuit Dog',
  },
  {
    value: 'Norwegian Buhund',
    label: 'Norwegian Buhund',
  },
  {
    value: 'Norwegian Elkhound',
    label: 'Norwegian Elkhound',
  },
  {
    value: 'Norwegian Lundehund',
    label: 'Norwegian Lundehund',
  },
  {
    value: 'Norwich Terrier',
    label: 'Norwich Terrier',
  },
  {
    value: 'Nova Scotia Duck Tolling Retriever',
    label: 'Nova Scotia Duck Tolling Retriever',
  },
  {
    value: 'Old English Sheepdog',
    label: 'Old English Sheepdog',
  },
  {
    value: 'Otterhound',
    label: 'Otterhound',
  },
  {
    value: 'Papillon',
    label: 'Papillon',
  },
  {
    value: 'Papipoo',
    label: 'Papipoo',
  },
  {
    value: 'Patterdale Terrier',
    label: 'Patterdale Terrier',
  },
  {
    value: 'Peekapoo',
    label: 'Peekapoo',
  },
  {
    value: 'Pekingese',
    label: 'Pekingese',
  },
  {
    value: 'Pembroke Welsh Corgi',
    label: 'Pembroke Welsh Corgi',
  },
  {
    value: 'Petit Basset Griffon Vendéen',
    label: 'Petit Basset Griffon Vendéen',
  },
  {
    value: 'Pharaoh Hound',
    label: 'Pharaoh Hound',
  },
  {
    value: 'Pitsky',
    label: 'Pitsky',
  },
  {
    value: 'Plott',
    label: 'Plott',
  },
  {
    value: 'Pocket Beagle',
    label: 'Pocket Beagle',
  },
  {
    value: 'Pointer',
    label: 'Pointer',
  },
  {
    value: 'Polish Lowland Sheepdog',
    label: 'Polish Lowland Sheepdog',
  },
  {
    value: 'Pomapoo',
    label: 'Pomapoo',
  },
  {
    value: 'Pomchi',
    label: 'Pomchi',
  },
  {
    value: 'Pomeagle',
    label: 'Pomeagle',
  },
  {
    value: 'Pomeranian',
    label: 'Pomeranian',
  },
  {
    value: 'Pomsky',
    label: 'Pomsky',
  },
  {
    value: 'Poochon',
    label: 'Poochon',
  },
  {
    value: 'Poodle',
    label: 'Poodle',
  },
  {
    value: 'Portuguese Podengo Pequeno',
    label: 'Portuguese Podengo Pequeno',
  },
  {
    value: 'Portuguese Pointer',
    label: 'Portuguese Pointer',
  },
  {
    value: 'Portuguese Sheepdog',
    label: 'Portuguese Sheepdog',
  },
  {
    value: 'Portuguese Water Dog',
    label: 'Portuguese Water Dog',
  },
  {
    value: 'Pudelpointer',
    label: 'Pudelpointer',
  },
  {
    value: 'Pug',
    label: 'Pug',
  },
  {
    value: 'Pugalier',
    label: 'Pugalier',
  },
  {
    value: 'Puggle',
    label: 'Puggle',
  },
  {
    value: 'Puginese',
    label: 'Puginese',
  },
  {
    value: 'Puli',
    label: 'Puli',
  },
  {
    value: 'Pyredoodle',
    label: 'Pyredoodle',
  },
  {
    value: 'Pyrenean Mastiff',
    label: 'Pyrenean Mastiff',
  },
  {
    value: 'Pyrenean Shepherd',
    label: 'Pyrenean Shepherd',
  },
  {
    value: 'Rat Terrier',
    label: 'Rat Terrier',
  },
  {
    value: 'Redbone Coonhound',
    label: 'Redbone Coonhound',
  },
  {
    value: 'Rhodesian Rvaluegeback',
    label: 'Rhodesian Rvaluegeback',
  },
  {
    value: 'Rottador',
    label: 'Rottador',
  },
  {
    value: 'Rottle',
    label: 'Rottle',
  },
  {
    value: 'Rottweiler',
    label: 'Rottweiler',
  },
  {
    value: 'Saint Berdoodle',
    label: 'Saint Berdoodle',
  },
  {
    value: 'Saint Bernard',
    label: 'Saint Bernard',
  },
  {
    value: 'Saluki',
    label: 'Saluki',
  },
  {
    value: 'Samoyed',
    label: 'Samoyed',
  },
  {
    value: 'Samusky',
    label: 'Samusky',
  },
  {
    value: 'Schipperke',
    label: 'Schipperke',
  },
  {
    value: 'Schnoodle',
    label: 'Schnoodle',
  },
  {
    value: 'Scottish Deerhound',
    label: 'Scottish Deerhound',
  },
  {
    value: 'Scottish Terrier',
    label: 'Scottish Terrier',
  },
  {
    value: 'Sealyham Terrier',
    label: 'Sealyham Terrier',
  },
  {
    value: 'Sheepadoodle',
    label: 'Sheepadoodle',
  },
  {
    value: 'Shepsky',
    label: 'Shepsky',
  },
  {
    value: 'Shetland Sheepdog',
    label: 'Shetland Sheepdog',
  },
  {
    value: 'Shiba Inu',
    label: 'Shiba Inu',
  },
  {
    value: 'Shichon',
    label: 'Shichon',
  },
  {
    value: 'Shih-Poo',
    label: 'Shih-Poo',
  },
  {
    value: 'Shih Tzu',
    label: 'Shih Tzu',
  },
  {
    value: 'Shikoku',
    label: 'Shikoku',
  },
  {
    value: 'Shiloh Shepherd',
    label: 'Shiloh Shepherd',
  },
  {
    value: 'Shiranian',
    label: 'Shiranian',
  },
  {
    value: 'Shollie',
    label: 'Shollie',
  },
  {
    value: 'Shorkie',
    label: 'Shorkie',
  },
  {
    value: 'Siberian Husky',
    label: 'Siberian Husky',
  },
  {
    value: 'Silken Windhound',
    label: 'Silken Windhound',
  },
  {
    value: 'Silky Terrier',
    label: 'Silky Terrier',
  },
  {
    value: 'Skye Terrier',
    label: 'Skye Terrier',
  },
  {
    value: 'Sloughi',
    label: 'Sloughi',
  },
  {
    value: 'Small Munsterlander Pointer',
    label: 'Small Munsterlander Pointer',
  },
  {
    value: 'Soft Coated Wheaten Terrier',
    label: 'Soft Coated Wheaten Terrier',
  },
  {
    value: 'Spanish Mastiff',
    label: 'Spanish Mastiff',
  },
  {
    value: 'Spinone Italiano',
    label: 'Spinone Italiano',
  },
  {
    value: 'Springador',
    label: 'Springador',
  },
  {
    value: 'Stabyhoun',
    label: 'Stabyhoun',
  },
  {
    value: 'Staffordshire Bull Terrier',
    label: 'Staffordshire Bull Terrier',
  },
  {
    value: 'Staffy Bull Bullmastiff',
    label: 'Staffy Bull Bullmastiff',
  },
  {
    value: 'Standard Schnauzer',
    label: 'Standard Schnauzer',
  },
  {
    value: 'Sussex Spaniel',
    label: 'Sussex Spaniel',
  },
  {
    value: 'Swedish Lapphund',
    label: 'Swedish Lapphund',
  },
  {
    value: 'Swedish Vallhund',
    label: 'Swedish Vallhund',
  },
  {
    value: 'Taiwan Dog',
    label: 'Taiwan Dog',
  },
  {
    value: 'Terripoo',
    label: 'Terripoo',
  },
  {
    value: 'Texas Heeler',
    label: 'Texas Heeler',
  },
  {
    value: 'Thai Rvaluegeback',
    label: 'Thai Rvaluegeback',
  },
  {
    value: 'Tibetan Mastiff',
    label: 'Tibetan Mastiff',
  },
  {
    value: 'Tibetan Spaniel',
    label: 'Tibetan Spaniel',
  },
  {
    value: 'Tibetan Terrier',
    label: 'Tibetan Terrier',
  },
  {
    value: 'Toy Fox Terrier',
    label: 'Toy Fox Terrier',
  },
  {
    value: 'Transylvanian Hound',
    label: 'Transylvanian Hound',
  },
  {
    value: 'Treeing Tennessee Brindle',
    label: 'Treeing Tennessee Brindle',
  },
  {
    value: 'Treeing Walker Coonhound',
    label: 'Treeing Walker Coonhound',
  },
  {
    value: 'Valley Bulldog',
    label: 'Valley Bulldog',
  },
  {
    value: 'Vizsla',
    label: 'Vizsla',
  },
  {
    value: 'Weimaraner',
    label: 'Weimaraner',
  },
  {
    value: 'Welsh Springer Spaniel',
    label: 'Welsh Springer Spaniel',
  },
  {
    value: 'Welsh Terrier',
    label: 'Welsh Terrier',
  },
  {
    value: 'West Highland White Terrier',
    label: 'West Highland White Terrier',
  },
  {
    value: 'Westiepoo',
    label: 'Westiepoo',
  },
  {
    value: 'Whippet',
    label: 'Whippet',
  },
  {
    value: 'Whoodle',
    label: 'Whoodle',
  },
  {
    value: 'Wirehaired Pointing Griffon',
    label: 'Wirehaired Pointing Griffon',
  },
  {
    value: 'Xoloitzcuintli',
    label: 'Xoloitzcuintli',
  },
  {
    value: 'Yakutian Laika',
    label: 'Yakutian Laika',
  },
  {
    value: 'Yorkipoo',
    label: 'Yorkipoo',
  },
  {
    value: 'Yorkshire Terrier',
    label: 'Yorkshire Terrier',
  },
];
